export default "__VITE_ASSET__CBWglmK6__"